import React from 'react';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import styled from 'styled-components';
import { CompareOfferBarChartData } from 'types/chart';
import { formatPriceToKorean } from 'utils/formatUtil';
import dayjs from 'dayjs';

interface Props {
  isVisibleDay: boolean;
}

function CompareOfferBarChartTooltip({
  active,
  payload,
  label,
  isVisibleDay,
}: TooltipProps<ValueType, NameType> & Props) {
  if (active && payload && payload.length) {
    const payloadData: CompareOfferBarChartData = payload?.[0].payload;
    const { date, difference } = payloadData;
    const formattedDate = dayjs(date).format(
      `YYYY년 MM월 ${isVisibleDay ? `DD일` : ''}`,
    );

    const getTooltipText = () => {
      if (difference) {
        if (difference < 0) {
          return '이 필요해요';
        }

        if (difference === 0) {
          return '이에요';
        }

        if (difference > 0) {
          return ' 남아요';
        }
      }

      return '';
    };

    return (
      <TooltipBox>
        <YearMonth>{formattedDate}</YearMonth>
        <TooltipText>
          차액{' '}
          <Price>{difference ? formatPriceToKorean(difference) : '-'}</Price>
          {getTooltipText()}
        </TooltipText>
      </TooltipBox>
    );
  }

  return null;
}

export default CompareOfferBarChartTooltip;

const TooltipBox = styled.div`
  font-size: 0.8rem;
  background: #fff;
  padding: 14px 14px;
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 30, 81, 0.12),
    0px 0px 8px 0px rgba(0, 30, 81, 0.04);
  line-height: 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const TooltipText = styled.div`
  color: #333;
  font-weight: 400;
`;

const Price = styled.span`
  font-weight: 700;
`;
const YearMonth = styled.div`
  color: #333;
  font-weight: 700;
  letter-spacing: -0.24px;
`;
